import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import HomePage from "@/pages/homePageV2/homePageComponents/HomePage";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
import useFullLoading from "@hooks/useFullLoading";
import useIsIOS from "@hooks/useIsIOS";
import { useEffect } from "react";
import { useCart } from "@/common/Contexts/CartContext";
function Home() {
  var fullPageData = useFullPageData(PageNamesEnum.PAGE_NAME__Home);
  var loading = useFullLoading();
  var isIos = useIsIOS();
  var _useCart = useCart(),
    seedCartMeta = _useCart.seedCartMeta;
  useEffect(function () {
    var _fullPageData$homeDat;
    var cart = fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$homeDat = fullPageData.homeDataNew) === null || _fullPageData$homeDat === void 0 ? void 0 : _fullPageData$homeDat.product_coupon_cart;
    if (cart) {
      seedCartMeta(cart.cart_id, cart.count);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!fullPageData) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hideOrangeHeadBtn: true,
    hasNavBar: true,
    pageName: "home",
    hasMobFooter: true,
    loading: loading,
    disableLoader: true,
    hasContactUs: true,
    authenticationMsg: true,
    hideHeadOnScroll: true,
    showUserAvatar: true,
    showCartIcon: __IS_CSR__,
    hideDownloadBanner: isIos
  }, /*#__PURE__*/React.createElement(HomePage, {
    data: fullPageData.homeDataNew
  }));
}
export default Home;